import presetPack from '@yandex-int/csp-presets-pack'

import {CSP, METRICA_DOMAINS} from '../../../../constants'
import type {Preset} from '../../../../types'

const metrikaPreset = presetPack.metrika(['ru']) as Preset

export const METRICA = {
  ...metrikaPreset,
  [CSP.CONNECT]: [...(metrikaPreset[CSP.CONNECT] || []), 'mc.yandex.ru'],
  [CSP.FRAME]: [...(metrikaPreset[CSP.FRAME] || []), 'yandex.ru'],
  [CSP.FRAME_ANCESTORS]: [...(metrikaPreset[CSP.FRAME_ANCESTORS] || []), ...METRICA_DOMAINS],
} as const satisfies Preset
